import * as React from 'react';

import {gameGeneralComponentPortrait, GameGeneralComponentPortraitConfigurationContext} from './gameGeneralComponentPortraitConfiguration';

const withGameGeneralComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameGeneralComponentPortraitConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameGeneralComponentPortrait}/>
                );
            }}
        </GameGeneralComponentPortraitConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameGeneralComponentConfiguration;